module.exports = __webpack_public_path__ + "static/media/secure-icon-grey.2b84d857.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/secure-icon-grey.svg
// module id = 1110
// module chunks = 14